import React from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';

import { checkIfNCSCodeIsValid } from '@/utils/color';
import { classnames } from '@/utils/html';
import theme from './SelectionWizardDialog.module.scss';

interface Props {
    value: string;
    onChange: (value: string) => void;
}

/**
 * NCS code input for CustomPaint products. Empty is allowed up front (the
 * input is required-on-save, not pre-validated), but a non-empty value
 * must validate as a real NCS code.
 */
export const NcsCodeStep: React.FC<Props> = ({ value, onChange }) => {
    const invalid = value.length > 0 && !checkIfNCSCodeIsValid(value);
    return (
        <label className={theme.customField}>
            <Trans>NCS input</Trans>
            <input
                type="text"
                aria-label={t`NCS input`}
                placeholder={t`Enter an NCS code`}
                className={classnames('form-control', { 'is-invalid': invalid })}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
            {invalid && (
                <small className={theme.customFieldError}>
                    <Trans>Not a valid NCS code</Trans>
                </small>
            )}
        </label>
    );
};
